/* =============================================================
   JMM Collections — filtre par univers + FLIP 2 rangées → 1 rangée
   + bandeau conseil qui suit l'univers. Multi-instances.
   ============================================================= */
(function () {
  'use strict';

  function initColl(root) {
    if (root.hasAttribute('data-jmc-init')) return;
    root.setAttribute('data-jmc-init', '1');

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var chips = Array.prototype.slice.call(root.querySelectorAll('.jmc__chip'));
    var grid = root.querySelector('.jmc__grid');
    var gwrap = root.querySelector('.jmc__gwrap');
    var pbar = root.querySelector('.jmc__pbar');
    var ass = root.querySelector('.jmc__ass');
    var bubble = root.querySelector('[data-jmc-bubble]');
    var place = root.querySelector('[data-jmc-place]');
    var assCta = root.querySelector('[data-jmc-cta]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('.jmc__card'));

    function upd() {
      if (!pbar || !gwrap) return;
      var max = gwrap.scrollWidth - gwrap.clientWidth;
      var r = max > 0 ? gwrap.scrollLeft / max : 0;
      pbar.style.width = (18 + r * 82) + '%';
    }

    function applyFilter(f, chip) {
      if (gwrap) gwrap.scrollLeft = 0;

      var first = null;
      if (!reduce) {
        first = new Map();
        cards.forEach(function (c) {
          if (!c.classList.contains('is-hidden')) first.set(c, c.getBoundingClientRect());
        });
      }

      cards.forEach(function (c) {
        var show = f === 'all' || c.getAttribute('data-u') === f;
        c.classList.toggle('is-hidden', !show);
      });
      grid.classList.toggle('is-one', f !== 'all');

      if (!reduce && first) {
        cards.forEach(function (c) {
          if (c.classList.contains('is-hidden')) return;
          var last = c.getBoundingClientRect();
          var fr = first.get(c);
          if (fr) {
            var dx = fr.left - last.left, dy = fr.top - last.top;
            if (dx || dy) {
              c.style.transition = 'none';
              c.style.transform = 'translate(' + dx + 'px,' + dy + 'px)';
              requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                  c.style.transition = 'transform .55s cubic-bezier(.22,1,.36,1)';
                  c.style.transform = '';
                });
              });
            }
          } else {
            c.style.transition = 'none';
            c.style.opacity = '0';
            c.style.transform = 'scale(.9)';
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                c.style.transition = 'opacity .45s ease, transform .45s cubic-bezier(.22,1,.36,1)';
                c.style.opacity = '';
                c.style.transform = '';
              });
            });
          }
          c.addEventListener('transitionend', function h() { c.style.transition = ''; c.removeEventListener('transitionend', h); });
        });
      }

      if (ass && chip) {
        var tx = chip.getAttribute('data-conseil');
        var ph = chip.getAttribute('data-place');
        var lk = chip.getAttribute('data-link');
        ass.classList.add('is-sw');
        window.setTimeout(function () {
          if (tx && bubble) bubble.innerHTML = tx;
          if (ph && place) place.textContent = ph;
          if (lk && assCta) assCta.setAttribute('href', lk);
          ass.classList.remove('is-sw');
        }, reduce ? 0 : 200);
      }
      window.setTimeout(upd, 80);
    }

    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.classList.remove('is-on'); });
        c.classList.add('is-on');
        applyFilter(c.getAttribute('data-f'), c);
      });
    });

    root.querySelectorAll('[data-jmc-nav]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (gwrap) gwrap.scrollBy({ left: parseInt(b.getAttribute('data-jmc-nav'), 10) * 340, behavior: 'smooth' });
      });
    });

    if (gwrap) gwrap.addEventListener('scroll', upd, { passive: true });
    upd();
  }

  function initAll() {
    document.querySelectorAll('.jmc').forEach(initColl);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () { window.setTimeout(initAll, 0); });
})();
